import React from "react"
import { clsx } from "clsx"
import {
  card,
  selectedPriceText,
  price,
  priceDescription,
  priceText,
} from "./Prices.css"

export interface PricesProps {
  highlightedPrice?: string
  primaryPrice: string
  primarySubtitle: string
  secondaryPrice: string
  secondarySubtitle: string
}

export const Prices: React.FC<PricesProps> = ({
  primaryPrice,
  primarySubtitle,
  secondaryPrice,
  secondarySubtitle,
  highlightedPrice = "primary",
}) => {
  const hasTypicalJourney = highlightedPrice === "secondary"
  const primaryStyles = clsx(price, !hasTypicalJourney && selectedPriceText)
  const secondaryStyles = clsx(price, hasTypicalJourney && selectedPriceText)

  return (
    <div
      data-testid="prices-wrapper"
      data-highlighted-price={highlightedPrice}
      className={card}
    >
      <div className={primaryStyles} data-testid="ProductCardMembersPriceText">
        <div className={priceText}>{primaryPrice}</div>
        <div className={priceDescription}>{primarySubtitle}</div>
      </div>
      <div
        className={secondaryStyles}
        data-testid="ProductCardTypicalPriceText"
      >
        <div className={priceText}>{secondaryPrice}</div>
        <div className={priceDescription}>{secondarySubtitle}</div>
      </div>
    </div>
  )
}
